var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Button',{on:{"click":_vm.call}},[_vm._v("\n    问卷调查\n  ")]),_c('Ccascade',{ref:"cas",staticStyle:{"width":"280px"},on:{"change":_vm._change}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }